import { Badge, Box, Flex, Heading, VStack } from '@chakra-ui/react';
import { countriesInfo, type Country } from '@/models/country';
import { Flag } from '../Flag';
import { useTeamDetail } from './TeamDetailContext';
import { TeamDetailPickRateChip } from './TeamDetailPickRateChip';
import { getTeamCategoryColorScheme, getTeamCategoryLabel } from './teamDetailUtils';

export function TeamDetailHero(props: { country: Country }) {
  const { pickRatesByCountry } = useTeamDetail();
  const pickRatePct = pickRatesByCountry?.[props.country];

  return (
    <Flex gap={4} align='flex-start' flexWrap='wrap' py={1}>
      <Flag country={props.country} w={{ base: '10rem', md: '12rem' }} borderRadius='3px' flexShrink={0} />
      <Box flex={1} minW={0} textAlign='left'>
        <Heading size='lg' lineHeight='short'>
          {countriesInfo[props.country].name}
        </Heading>
        <VStack align='flex-start' mt={2} spacing={1.5}>
          <Badge colorScheme={getTeamCategoryColorScheme(props.country)} borderRadius='full' px={3}>
            {getTeamCategoryLabel(props.country)}
          </Badge>
          {pickRatePct != null ? <TeamDetailPickRateChip pickRatePct={pickRatePct} /> : null}
        </VStack>
      </Box>
    </Flex>
  );
}
